import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const WalletAuthContext = createContext(null);

export const WalletAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('wallet_token');
    const storedUser = localStorage.getItem('wallet_user');
    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
        setIsAuthenticated(true);
      } catch { /* invalid JSON */ }
    }
    setLoading(false);
  }, []);

  const login = useCallback((token, userData) => {
    // Phase 1: Still store to localStorage as fallback for pre-cookie sessions.
    // The httpOnly cookie is set by the server automatically.
    // Remove localStorage token storage after 7 days post-deploy.
    const fullUserData = { ...userData, user_type: userData.user_type || userData.role };
    localStorage.setItem('wallet_token', token);
    localStorage.setItem('wallet_user', JSON.stringify(fullUserData));
    setUser(fullUserData);
    setIsAuthenticated(true);
    return fullUserData;
  }, []);

  const logout = useCallback(async () => {
    // Clear server-side httpOnly cookie
    try {
      await axios.post('/api/auth/logout', {}, { withCredentials: true });
    } catch { /* best-effort */ }
    // Clear localStorage fallback
    localStorage.removeItem('wallet_token');
    localStorage.removeItem('wallet_user');
    setUser(null);
    setIsAuthenticated(false);
    window.location.href = '/login';
  }, []);

  return (
    <WalletAuthContext.Provider value={{ user, loading, isAuthenticated, login, logout }}>
      {children}
    </WalletAuthContext.Provider>
  );
};

export const useWalletAuth = () => {
  const ctx = useContext(WalletAuthContext);
  if (!ctx) throw new Error('useWalletAuth must be within WalletAuthProvider');
  return ctx;
};
